import { render } from "./TemplateTab.vue?vue&type=template&id=4f11a69c"
import script from "./TemplateTab.vue?vue&type=script&lang=js"
export * from "./TemplateTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__